import Orchestrator from "../Orchestrator.js";
import Environment from "./Environment.js";
import GaussianSplats from "./GaussianSplats.js";

export default class Stage {
    constructor() {
        this.orc = new Orchestrator();
        this.scene = this.orc.scene;

        this.resources = this.orc.resources;
        // Wait for resources
        this.orc.emitter.on("ready", () => {
            // Setup
            this.environment = new Environment();
            this.gaussianSplats = new GaussianSplats();
        });
    }

    // both time params are measured in seconds
    update(elapsed, delta) {
        if (this.gaussianSplats) {
            this.gaussianSplats.update(elapsed, delta);
        }
    }
}
